import LocaleManager from '../utils/LocaleManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import StateButton from '../controls/StateButton.js';
import PopupManager from '../utils/PopupManager.js';
import SoundManager from '../utils/SoundManager.js';

export default class EndBonusRoundPopup extends Phaser.Group {
    constructor(game)
    {
        super(game);

        this.onClose = new Phaser.Signal();
        this.redraw();
    }

    redraw()
    {
        this.removeAll(true, true);
        const game = this.game;

        let bg = this._bg = new Phaser.Image(game, 0, 0, 'popups.bonus-spin.bg');
        this.addChild(bg);

        let close = new StateButton(game, 0, 0, 'buttons.accept', () =>
        {
            SoundManager.playSound('sounds/touch');
            this.onClose.dispatch();
        });
        close.position.set(
            bg.width - close.width >> 1,
            bg.height - close.hitArea.height - 50
        );
        this.addChild(close);

        const localeFontSettings = {
                'cs': {
                    fontSize: {
                        [Config.DESKTOP]: 32,
                        [Config.LANDSCAPE]: 32,
                        [Config.PORTRAIT]: 32
                    }
                },
                'de': {
                    fontSize: {
                        [Config.DESKTOP]: 34,
                        [Config.LANDSCAPE]: 34,
                        [Config.PORTRAIT]: 34
                    }
                },
                'el': {
                    fontSize: {
                        [Config.DESKTOP]: 32,
                        [Config.LANDSCAPE]: 32,
                        [Config.PORTRAIT]: 30
                    }
                },
                'es': {
                    fontSize: {
                        [Config.DESKTOP]: 24,
                        [Config.LANDSCAPE]: 24,
                        [Config.PORTRAIT]: 30
                    }
                },
                'fi': {
                    fontSize: {
                        [Config.DESKTOP]: 36,
                        [Config.LANDSCAPE]: 36,
                        [Config.PORTRAIT]: 36
                    }
                },
                'fr': {
                    fontSize: {
                        [Config.DESKTOP]: 50,
                        [Config.LANDSCAPE]: 50,
                        [Config.PORTRAIT]: 46
                    }
                },
                'hu': {
                    fontSize: {
                        [Config.DESKTOP]: 32,
                        [Config.LANDSCAPE]: 32,
                        [Config.PORTRAIT]: 32
                    }
                },
                'is': {
                    fontSize: {
                        [Config.DESKTOP]: 36,
                        [Config.LANDSCAPE]: 32,
                        [Config.PORTRAIT]: 32
                    }
                },
                'it': {
                    fontSize: {
                        [Config.DESKTOP]: 40,
                        [Config.LANDSCAPE]: 40,
                        [Config.PORTRAIT]: 38
                    }
                },
                'lv': {
                    fontSize: {
                        [Config.DESKTOP]: 26,
                        [Config.LANDSCAPE]: 26,
                        [Config.PORTRAIT]: 26
                    }
                },
                'nl': {
                    fontSize: {
                        [Config.DESKTOP]: 50,
                        [Config.LANDSCAPE]: 50,
                        [Config.PORTRAIT]: 36
                    }
                },
                'no': {
                    fontSize: {
                        [Config.DESKTOP]: 36,
                        [Config.LANDSCAPE]: 50,
                        [Config.PORTRAIT]: 36
                    }
                },
                'pl': {
                    fontSize: {
                        [Config.DESKTOP]: 30,
                        [Config.LANDSCAPE]: 30,
                        [Config.PORTRAIT]: 30
                    }
                },
                'pt': {
                    fontSize: {
                        [Config.DESKTOP]: 32,
                        [Config.LANDSCAPE]: 32,
                        [Config.PORTRAIT]: 32
                    }
                },
                'sr': {
                    fontSize: {
                        [Config.DESKTOP]: 34,
                        [Config.LANDSCAPE]: 34,
                        [Config.PORTRAIT]: 34
                    }
                },
                'sv': {
                    fontSize: {
                        [Config.DESKTOP]: 50,
                        [Config.LANDSCAPE]: 50,
                        [Config.PORTRAIT]: 40
                    }
                },
                'tr': {
                    fontSize: {
                        [Config.DESKTOP]: 36,
                        [Config.LANDSCAPE]: 36,
                        [Config.PORTRAIT]: 36
                    }
                },
        }[LocaleManager.locale] || {
            fontSize: {
                [Config.DESKTOP]: 50,
                [Config.LANDSCAPE]: 50,
                [Config.PORTRAIT]: 50
            }
        };

        let title = new Phaser.Text(game, bg.width >> 1, 180, LocaleManager.getString('popup_end_bonus_round.title'), {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: localeFontSettings.fontSize[Config.layout],
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: bg.width - 60,
            align: 'center'
        });
        title.lineSpacing = -16;
        title.anchor.set(0.5);
        this.addChild(title);

        let money = this._money = new Phaser.Text(game, bg.width >> 1, 90, '-', {
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize: 50,
            fill: '#D9B869'
        });
        money.anchor.x = 0.5;
        this.addChild(money);

        if (this._showArguments)
        {
            this.show.apply(this, this._showArguments);
        }
    }

    show(money)
    {
        if (SoundManager.sound && !this._showArguments)
        {
            SoundManager.playSound('sounds/bonus-win', false, true);
        }

        this._showArguments = arguments;
        this._money.text = Utils.formatMoney(money);
    }

    alignToWorld()
    {
        this.position.set(
            Config.GAME_WIDTH - this.width >> 1,
            (Config.GAME_HEIGHT - this.height >> 1) - 20
        );
    }
}